Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterFollowButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TwitterFollowButton = function TwitterFollowButton(_ref) {
  var username = _ref.username,
    _ref$showFollowers = _ref.showFollowers,
    showFollowers = _ref$showFollowers === void 0 ? false : _ref$showFollowers,
    _ref$showUsername = _ref.showUsername,
    showUsername = _ref$showUsername === void 0 ? true : _ref$showUsername,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-follow-button",
    href: "https://twitter.com/".concat(username, "?ref_src=twsrc%5Etfw"),
    className: "twitter-follow-button twitter-follow-button-mdx-embed",
    "data-show-count": showFollowers,
    "data-show-screen-name": showUsername,
    "data-size": size
  }, "Follow @".concat(username)));
};
exports.TwitterFollowButton = TwitterFollowButton;